import { Types } from './types'

const initialState = {
    dataOrderCSV: {
        filter: {},
        rows: []
    },
    currentRecord: null
}
const orderCSVReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_ORDER_EXPORT_CSV:
            return {
                ...newState,
                dataOrderCSV: action.payload
            }
        case Types.SET_RECORD:
            return {
                ...newState,
                currentRecord: action.payload
            }
        default:
            return { ...newState }
    }
}
export default orderCSVReducer
